// extracted by mini-css-extract-plugin
module.exports = {"loading-icon":"infinite-list-loading_loading-icon__EyHrf","infinite-list-loading-rotate":"infinite-list-loading_infinite-list-loading-rotate__hpniN"};